
import { Component, Prop, Vue } from "vue-property-decorator";
import AudioStyle from "@/components/videoPaly/audioStyle.vue";
import { QuestionConfig } from "@/lib/model/exam/candidate-result";

@Component({ components: { AudioStyle } })
export default class Replenish extends Vue {
  @Prop({ required: true }) q!: QuestionConfig;

  isPlaying = false;

  playAudioDesc() {
    const audioElements = Array.from(document.querySelectorAll("audio"));
    const currentAudio = audioElements.find(
      audioElement => audioElement.id === `player${this.q.questionId}`
    );

    if (currentAudio && !currentAudio.paused) {
      //此音频正在播放，则暂停
      currentAudio.pause();
      this.isPlaying = false;
      return;
    } else {
      this.$emit("playAudioDesc", this.q);
      this.isPlaying = true;
    }
  }
}
